export const AuctionSortType = {
  ENDING_SOONEST: 'ENDING_SOONEST',
  LATEST_ADDED: 'LATEST_ADDED',
};

export const AuctionSortTypeName = {
  ENDING_SOONEST: 'Ending soonest',
  LATEST_ADDED: 'Latest added',
};
